/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskAlexaRanking } from './ExecRiskAlexaRanking';
import {
    ExecRiskAlexaRankingFromJSON,
    ExecRiskAlexaRankingFromJSONTyped,
    ExecRiskAlexaRankingToJSON,
} from './ExecRiskAlexaRanking';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedAlexaResponse
 */
export interface ExecRiskPaginatedAlexaResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedAlexaResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskAlexaRanking>}
     * @memberof ExecRiskPaginatedAlexaResponse
     */
    results: Array<ExecRiskAlexaRanking>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedAlexaResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedAlexaResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedAlexaResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedAlexaResponse interface.
 */
export function instanceOfExecRiskPaginatedAlexaResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedAlexaResponseFromJSON(json: any): ExecRiskPaginatedAlexaResponse {
    return ExecRiskPaginatedAlexaResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedAlexaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedAlexaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskAlexaRankingFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedAlexaResponseToJSON(value?: ExecRiskPaginatedAlexaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskAlexaRankingToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

